import { Expose } from 'class-transformer';

import { Plunk } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnApplianceStatus } from '../appliance';

export class SnExternalAppliance extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public type: string;

  @Expose()
  @Plunk('id', { toPlainOnly: true, groups: ['form'] })
  public appliance: string;

  @Expose()
  public host: number;

  @Expose()
  public serverVersion: string;

  @Expose()
  public cameraCount: string;

  @Expose()
  public port: number;

  @Expose()
  public username: string;

  @Expose()
  public password: boolean;

  @Expose()
  public status: SnApplianceStatus;

  @Expose()
  public statusMessage: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
